export default __webpack_public_path__ + "3d587b79c339d10ab2fd645d72e564fe.png";